import { useCallback } from "react";

import { useProductDummyRoomFormModelContext } from "../../../../context";

export const useDummyRoomName = () => {
	const { viewModel, onSetViewModel } = useProductDummyRoomFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
